export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-10">
          关于平台
        </h2>
        <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12">
          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="flex-shrink-0 w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-vidicon-line text-3xl text-primary-600"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold text-foreground-900 font-heading mb-4">
                国产91视频 - 您值得信赖的在线视频资源导航
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                国产91视频成立于在线视频行业蓬勃发展之际，始终致力于为广大用户提供高效、便捷、全面的视频资源导航服务。我们深度整合久久视频、芒果视频、97视频、丝瓜视频、蓝莓视频等主流在线视频网站资源，通过视频播放器在线看视频的技术方案，让用户无需在多个站点间反复跳转即可发现精彩内容。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                我们的核心理念是"聚合优质资源，简化浏览体验"。平台不仅提供视频站点入口导航，更注重内容的持续更新与站点的可用性保障。每日巡检团队会对收录的在线视频网站进行状态监控，确保97视频、丝瓜视频等热门站点的访问稳定。同时，我们关注用户反馈，持续优化视频播放器在线看视频的整体体验。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                截至目前，国产91视频已覆盖超过200个视频资源站点，日均服务用户数稳步增长。我们始终秉持开放、免费、安全的运营原则，欢迎广大视频爱好者通过本站发现更多优质在线视频资源。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}